import { useMemo } from 'react';

import _ from 'lodash';
import { useRecoilValue } from 'recoil';

import { useBohNav } from '../use-boh-nav';

import { searchTermAtom } from './search-term';

import type { BohLink } from '../use-boh-nav';

export function useFilteredNav(): BohLink[] {
  const links = useBohNav();

  const filter = useRecoilValue(searchTermAtom);

  const filteredLinks = useMemo(() => {
    if (!filter) {
      return [];
    }

    const clonedLinks = _.cloneDeep(links);

    clonedLinks.forEach((link) => {
      link.subNavItems = link.subNavItems?.filter((subNavItem) =>
        subNavItem.label.toLowerCase().includes(filter.toLowerCase())
      );
    });

    const filteredLinks = clonedLinks.filter((clonedLink) => (clonedLink.subNavItems?.length ?? 0) > 0);

    return filteredLinks;
  }, [links, filter]);

  return filteredLinks;
}
